<template>
    <section class="scc-drawing">
        <h3 class="scc-drawing__title">Trekking van {{ formatDate(drawing.startAt) }}</h3>
        <ul class="scc-drawing__prize-list">
            <Prize v-for="prize in drawing.prizes" :key="prize.id" v-bind="prizeOptions(prize)" />
            <li class="scc-prize-filler">
                <PrizeFiller />
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    name: 'Drawing',
    __editor: {
        requiredData: ['drawings'],
    },
    props: ['drawing'],
    methods: {
        prizeOptions(prize) {
            const { description, id, image, quantity, reference, sponsor } = prize;

            return {
                description,
                id,
                image,
                quantity,
                reference,
                sponsor,
            };
        },
        formatDate(date) {
            let dateObject = new Date(date);
            let day = String(dateObject.getDate()).padStart(2, '0');
            let month = String(dateObject.getMonth() + 1).padStart(2, '0');
            let year = dateObject.getFullYear();
            // let hour = ('0' + dateObject.getHours()).slice(-2);
            // let minute = ('0' + dateObject.getMinutes()).slice(-2);

            return day + '-' + month + '-' + year;
        },
    },
};
</script>

<style lang="scss">
.scc-drawing {
    &__prize-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .scc-prize-filler {
        display: flex;
        flex: 1;
    }
}
</style>
